if(!window.__soarHoopRef){window.__soarHoopRef=1;

// Sticky bar: show when scrolled past hero
const hero = document.querySelector('.pdp-hero');
const bar  = document.getElementById('stickyBar');
if(hero && bar){
  const obs = new IntersectionObserver(entries=>{
    entries.forEach(e=>{
      bar.classList.toggle('visible', !e.isIntersecting);
    });
  },{threshold:0});
  obs.observe(hero);
}

// FAQ toggle is handled inline via onclick

;

// Talking SOAR Swiper (guarded — only if Swiper is loaded and the carousel exists)
const talkingSwiper = (window.Swiper && document.querySelector('.talking-swiper')) ? new Swiper('.talking-swiper', {
  slidesPerView: 'auto',
  spaceBetween: 16,
  grabCursor: true,
  freeMode: { enabled: true, sticky: false },
  navigation: {
    prevEl: '.talking-prev',
    nextEl: '.talking-next',
  },
  breakpoints: {
    0:    { slidesPerView: 1.3, spaceBetween: 12 },
    480:  { slidesPerView: 2.2, spaceBetween: 14 },
    768:  { slidesPerView: 3.3, spaceBetween: 16 },
    1100: { slidesPerView: 4.2, spaceBetween: 20 },
  },
  on: {
    slideChange: function(){
      const el = document.querySelector('.talking-counter .current');
      if(el) el.textContent = this.activeIndex + 1;
    }
  }
}) : null;

;

(function(){
  function init(){
    document.querySelectorAll('.pdetails').forEach(function(sec){
      sec.querySelectorAll('.pd-tab').forEach(function(t){
        t.addEventListener('click',function(){
          var id=t.getAttribute('data-tab');
          sec.querySelectorAll('.pd-tab').forEach(function(x){x.classList.toggle('active',x===t);});
          sec.querySelectorAll('.pd-panel').forEach(function(pn){pn.classList.toggle('active',pn.getAttribute('data-panel')===id);});
        });
      });
    });
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();

;

(function(){
  function init(){
    document.querySelectorAll('.pfeat').forEach(function(stage){
      var dots=stage.querySelectorAll('.pf-dot');
      var tabs=stage.querySelectorAll('.pf-tab');
      var slides=stage.querySelectorAll('.pf-slide');
      var num=stage.querySelector('.pf-index span');
      var arrows=stage.querySelectorAll('.pf-arrow');
      var total=slides.length, cur=0;
      function show(i){
        cur=(i+total)%total;
        dots.forEach(function(d){d.classList.toggle('active',+d.dataset.i===cur);});
        tabs.forEach(function(t){t.classList.toggle('active',+t.dataset.i===cur);});
        slides.forEach(function(sl){sl.classList.toggle('active',+sl.dataset.i===cur);});
        if(num) num.textContent=String(cur+1).padStart(2,'0');
      }
      dots.forEach(function(d){d.addEventListener('click',function(){show(+d.dataset.i);});});
      tabs.forEach(function(t){t.addEventListener('click',function(){show(+t.dataset.i);});});
      if(arrows[0]) arrows[0].addEventListener('click',function(){show(cur-1);});
      if(arrows[1]) arrows[1].addEventListener('click',function(){show(cur+1);});
    });
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();

;

(function(){
  function init(){
    var sec=document.getElementById('how-it-works'); if(!sec) return;
    var drawer=document.getElementById('hiwDrawer');
    var backdrop=document.getElementById('hiwBackdrop');
    var dots=sec.querySelectorAll('.hiw-dot');
    var slides=drawer.querySelectorAll('.hiw-slide');
    var total=slides.length, cur=0;
    function render(i){cur=(i+total)%total;slides.forEach(function(s){s.classList.toggle('active',+s.dataset.i===cur);});drawer.querySelector('.hiw-slides').scrollTop=0;}
    function open(i){render(i);drawer.classList.add('open');backdrop.classList.add('open');drawer.setAttribute('aria-hidden','false');}
    function close(){drawer.classList.remove('open');backdrop.classList.remove('open');drawer.setAttribute('aria-hidden','true');}
    dots.forEach(function(d){d.addEventListener('click',function(){open(+d.dataset.i);});});
    document.getElementById('hiwClose').addEventListener('click',close);
    backdrop.addEventListener('click',close);
    document.getElementById('hiwPrev').addEventListener('click',function(){render(cur-1);});
    document.getElementById('hiwNext').addEventListener('click',function(){render(cur+1);});
    document.addEventListener('keydown',function(e){if(e.key==='Escape')close();});
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();

}